<template>
  <div class="upload-image">
    <h4>
      {{ $t('components.MediaImage.addImage') }}
      ({{ images.length }}{{ $t('components.MediaImage.unit') }})
      {{ labelDetail }}
      <slot name="labelContent" />
    </h4>
    <div v-show="loading" class="upload-image__wrapper loading">
      <Loading />
    </div>

    <div v-show="!loading" class="upload-image__wrapper" :class="{ selected: images.length }">
      <div v-for="image in images" :key="image.id" class="upload-image__content">
        <img :src="image.url" :alt="image.name" class="upload-image__image">

        <div class="c-button c-button--icon">
          <button class="c-button__item" type="button" @click.prevent="removeImage(image.id)">
            <Icon name="iconCross" class="c-button__icon" />
            {{ $t('labels.delete') }}
          </button>
        </div>
      </div>
    </div>

    <ValidationObserver ref="mediaImageObserver">
      <ValidationProvider
        v-slot="{ errors, handleChange }"
        :rules="rules"
        value=""
        :name="$t('labels.image')"
        @update:model-value="dropImages"
      >
        <div class="c-button c-button--icon">
          <label class="c-button__item c-button__item--primary">
            <input
              ref="file"
              type="file"
              class="u-hidden"
              accept="image/*"
              :disabled="loading || images.length >= maxFiles"
              :multiple="!maxFiles || maxFiles > 1"
              @change="handleChange"
              @click="(e) => { e.target.value = '' }"
            >
            <Icon name="iconPlus" class="imageAdd__icon" />
            {{ $t('components.MediaImage.selectImage') }}
          </label>
        </div>

        <ValidationError
          id="mediaImages"
          :error="errors[0]"
        />
        <ValidationError
          id="mediaImagesLengthError"
          :error="maxLengthError"
        />
      </ValidationProvider>
    </ValidationObserver>
  </div>
</template>

<script>
import Icon from '../components/Icon'
import Loading from '../components/Loading'
import ValidationError from './ValidationError'

export default {
  name: 'MediaImage',
  components: {
    Icon,
    Loading,
    ValidationError,
  },
  props: {
    images: {
      type: Array,
      required: true
    },
    maxFiles: {
      type: Number,
    },
    loading: {
      type: Boolean,
      required: true
    },
    labelDetail: {
      type: String,
      default: ''
    },
    rules: {
      type: String,
      default: 'image|postImage|size:10000'
    },
  },
  emits: ['drop-images', 'remove-image'],
  data() {
    return {
      maxLengthError: '',
    }
  },
  methods: {
    async dropImages(event) {
      const { valid } = await this.$refs.mediaImageObserver.validate()
      if (!valid) {
        return
      }

      const allPhotosLength = this.images.length + event.length

      this.maxLengthError = ''

      if (this.maxFiles && allPhotosLength > this.maxFiles) {
        this.maxLengthError = this.$t('components.MediaImage.maxLengthError', { count: this.maxFiles })
        return
      }
      let targetImages = event
      if (!Array.isArray(targetImages)) {
        targetImages = [targetImages]
      }
      // files は map では回せないため新しく配列を用意している
      const _images = []
      targetImages.forEach(image => {
        _images.push(image)
      })
      this.$emit('drop-images', _images)
    },
    async removeImage(imageId) {
      this.$emit('remove-image', imageId)
    }
  }
}
</script>

<style lang="scss" scoped>
.upload-image {
  &__wrapper {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    height: 250px;
    padding: 24px;
    background-color: rgba(245, 245, 245, 0.5);
    border: 1px solid #E4E7EB;
    border-radius: 4px;
    &.loading {
      background-color: #ffffff;
      display: block;
    }

    &.selected {
      background-color: #ffffff;
      height: auto;
      padding-bottom: 8px;
    }
  }

  &__content {
    flex: none;
    width: calc(176px + 24px);
    height: calc(176px + 40px);
    padding-bottom: 40px;
    padding-right: 24px;

    .c-button {
      margin: 0;
    }

    .c-button__item {
      padding: 0;
    }
  }

  &__image {
    display: block;
    width: 100%;
    height: 100%;
    margin-bottom: 8px;
    object-fit: cover;
    border: 1px solid #E3E3E3;
    border-radius: 4px;
  }
}

.imageAdd {
  &__icon {
    width: 16px;
    margin-right: 8px;

  }
}
</style>
